module.exports = __webpack_public_path__ + "static/NeuzeitGro-Lig-f0de19fe9f5bd133e37b67fe0b1daf54.woff";